module.exports = __webpack_public_path__ + "pivot.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/pivot.svg?color1=%23333333&color2=
// module id = 2209
// module chunks = 67